import { render, staticRenderFns } from "./RatingTab.vue?vue&type=template&id=0cb539f2"
import script from "./RatingTab.vue?vue&type=script&lang=js"
export * from "./RatingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports